import moment from 'moment/moment'

class KlaviyoList extends HTMLElement {
  constructor() {
    super()
    this.name = ''
  }
  connectedCallback() {
    let formValidated = []
    const postForm = (klaviyoData) => {
      fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
        method: 'POST', // or 'PUT'
        headers: {
          'content-type': 'application/x-www-form-urlencoded',
          'cache-control': 'no-cache',
        },
        body: klaviyoData,
      })
        .then((response) => response.json())
        .then((data) => {
          if (this.querySelector('#name')) {
            this.name = this.querySelector('#name').value
          } else if (this.querySelector('#first_name')) {
            this.name = this.querySelector('#first_name').value
          }
          if (this.getAttribute('sell-your-soul-flow') == 'true') {
            window.location.href =
              '/pages/soul-contract?name=' +
              this.name +
              '&email=' +
              encodeURIComponent(this.querySelector('#email').value) +
              '&date=' +
              encodeURIComponent(moment().format('MMMM DD YYYY'))
          } else {
            document
              .querySelector('#thank-you-modal')
              .classList.remove('hidden')
          }
        })
        .catch((error) => {
          alert(error)
        })
    }

    this.querySelector('#form-submit').addEventListener('click', (e) => {
      e.preventDefault()

      const data = {
        g: this.getAttribute('list-id'),
        $fields: 'event, shopify_tags, $source, $accepts_marketing',
        event: this.getAttribute('event'),
        shopify_tags: this.getAttribute('shopify_tags'),
        $source: this.getAttribute('source'),
        $accepts_marketing: true,
      }

      this.querySelectorAll('.form-field').forEach((e, index) => {
        const key = e.id.replace(/-/g, '_')
        const value = e.value
        data.$fields += `, ${key}`
        data[key] = value
      })

      const urlData = new URLSearchParams(data)

      this.querySelectorAll('input').forEach((e, index) => {
        if (e.reportValidity() == false) {
          formValidated[index] = false
        } else {
          formValidated[index] = true
        }
      })

      let checker = (arr) => arr.every(Boolean)
      if (checker(formValidated) == false) {
      } else {
        postForm(urlData)
      }
    })
  }
}
customElements.define('klaviyo-list', KlaviyoList)
